import { Divider as SUIDivider, Segment } from 'semantic-ui-react';

type DividerData = {
  clearing?: boolean;
  fitted?: boolean;
  hidden?: boolean;
  section?: boolean;
};

type DividerViewProps = {
  data?: DividerData;
};

const DividerView = ({ data = {} }: DividerViewProps) => {
  const { clearing, fitted, hidden, section } = data;

  return (
    <Segment basic>
      <SUIDivider
        clearing={clearing}
        fitted={fitted}
        hidden={hidden}
        section={section}
      />
    </Segment>
  );
}

export default DividerView;